<template>
  <span
    class="dropdown dropdown-end translate-field-dropdown"
    @mouseenter="renderDropdown = true"
    @touchstart="renderDropdown = true"
  >
    <label
      tabindex="0"
      :title="t('translate')"
      class="relative cursor-pointer text-transparent group-hover:text-base-content"
      @click.stop
    >
      <IconLanguage
        :width="18"
        :stroke-width="1.6"
        :class="{ 'animate-pulse': isTranslating }"
      />
    </label>
    <ul
      v-if="renderDropdown"
      tabindex="0"
      class="mt-1.5 dropdown-content menu menu-xs p-2 shadow rounded-box w-40 z-10"
      :style="{ backgroundColor: dropdownBgColor }"
      draggable="true"
      @dragstart.prevent.stop
      @click.stop
    >
      <li
        v-for="lang in languages"
        :key="lang.code"
      >
        <a
          href="#"
          class="text-sm py-1 px-2"
          @click.prevent="translateTo(lang.code)"
        >
          {{ lang.label }}
        </a>
      </li>
    </ul>
  </span>
</template>

<script>
import { IconLanguage } from '@tabler/icons-vue'

// Generic translate-to-language button. Emits 'translated' with the
// translated string on success; on failure it alerts (matching the rest of
// the builder's error UX — see builder.vue's `alert(...)` calls) and leaves
// the original text untouched so nothing is ever silently clobbered.
export default {
  name: 'TranslateButton',
  components: {
    IconLanguage
  },
  inject: ['baseFetch', 't'],
  props: {
    text: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['translated'],
  data () {
    return {
      renderDropdown: false,
      isTranslating: false
    }
  },
  computed: {
    dropdownBgColor () {
      return ['', null, 'transparent'].includes(this.backgroundColor) ? 'white' : this.backgroundColor
    },
    languages () {
      return [
        { code: 'es', label: this.t('language_es') },
        { code: 'fr', label: this.t('language_fr') },
        { code: 'de', label: this.t('language_de') },
        { code: 'pt', label: this.t('language_pt') },
        { code: 'zh', label: this.t('language_zh') },
        { code: 'vi', label: this.t('language_vi') },
        { code: 'ko', label: this.t('language_ko') },
        { code: 'ar', label: this.t('language_ar') }
      ]
    }
  },
  methods: {
    translateTo (targetLanguage) {
      if (this.isTranslating || !this.text) return

      this.isTranslating = true

      this.baseFetch('/translations', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ text: this.text, target_language: targetLanguage })
      }).then(async (resp) => {
        const data = await resp.json()

        if (resp.ok) {
          this.$emit('translated', data.translated_text)
        } else {
          alert(data.error || this.t('unable_to_translate'))
        }
      }).catch(() => {
        alert(this.t('unable_to_translate'))
      }).finally(() => {
        this.isTranslating = false
        this.renderDropdown = false
        this.$el.getRootNode().activeElement?.blur()
      })
    }
  }
}
</script>
